<div class="wcl-engine-settings">
  <div class="section-title">
    <h3>Active Engine</h3>
  </div>
  <div class="engine-toggles">
    <mat-button-toggle-group
      [value]="activeEngine"
      (change)="onEngineSelectionChange($event.value)"
      aria-label="Select active engine"
    >
      @for (api of wclApis; track api.name) {
      <mat-button-toggle
        [value]="api.name"
        [attr.aria-label]="'Select ' + api.name + ' engine'"
      >
        {{ api.name }}
      </mat-button-toggle>
      }
    </mat-button-toggle-group>
  </div>
</div>
